import React, { useRef } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem"; 
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';


function GCEasyPutAwayMenuBtn({ menuLabel, menuItems, xvariant=""}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    document.getElementsByName("MoreBtn")[0]?.blur();
  };

  return (
    <div >
      <Button
        id="basic-button"
        className="GCEasyPutAwayMenuBtn "
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant={xvariant}
        startIcon={<MoreHorizIcon />}
      >
        {menuLabel}
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {menuItems.map((menuItem, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              menuItem.onClick();
              handleClose();
            }}
          >
            {menuItem.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default GCEasyPutAwayMenuBtn;
